import React, { PureComponent } from 'react'
import { Modal, Col, Button } from 'react-bootstrap'
import { reduxForm, Field } from 'redux-form'
import InputText from '../../commons/form/InputText'
import SimpleTablePage from '../../../containers/commons/general/SimpleTablePage'
import { handleKeyDown } from '../../../util/utils'

class MaritalStatusMasterModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      type: null,
      values: null,
      deleted: false
    }
    this.required = this.required.bind(this)
  }

  submitDocument (values) {
    const MaritalStatusLanguages = []
    Object.keys(values).map(item => {
      if (item.includes('lang')) {
        MaritalStatusLanguages.push(values[item])
      }
    })
    var maritalStatus = {}
    maritalStatus.maritalStatusId = this.props.maritalStatus?.maritalStatusId
    maritalStatus.code = values.code
    maritalStatus.MaritalStatusLanguages = MaritalStatusLanguages

    this.props.actions.submitMaritalStatus(maritalStatus)
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    if (!this.state.deleted && this.props.maritalStatus !== null && (this.props.maritalStatus?.value)?.length > this.state.values) {
      const count = (this.props.maritalStatus?.value)?.length
      this.setState({ values: count })
    }
    if (prevProps.showModal !== this.props.showModal && this.props.showModal === true) {
      this.props.initialize(this.props.maritalStatus)
      this.props.languageList?.map((language) => {
        this.props.change(`lang${language.languageId}.languageId`, language.languageId)
        const source = (this.props.maritalStatus?.maritalStatusId) ? this.props.maritalStatus.maritalStatusLanguages.find((sourceChannel) => sourceChannel.languageId === language.languageId) : ''
        this.props.change(`lang${language.languageId}.name`, source ? source.name : '')
        this.props.change(`lang${language.languageId}.description`, source ? source.description : '')
      })
    }
  }

  required (value) {
    if (value || value === 0) {
      return undefined
    } else {
      return this.props.t('MASTERS.MARITAL_STATUS_MASTERS.VALIDATION.VALUE_REQUIRED')
    }
  }

  render () {
    const {
      t, handleSubmit,
      showModal, languageList
    } = this.props
    const tKey = 'MASTERS.MARITAL_STATUS_MASTERS.MODAL.'
    return (
      <Modal id="maritalStatusMasterModal" className="_nf" show={showModal} onHide={this.props.actions.closeMaritalStatusMasterModal} backdrop={'static'}>
        <form autoComplete="off" onSubmit={handleSubmit(this.submitDocument.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton onHide={this.props.actions.closeMaritalStatusMasterModal}>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="search-form">
              <Field
                component={InputText}
                colWidth={100} // 25, 33, 50, 75, 100 default=25
                t={t}
                id='code'
                name='code'
                placeholder={t(`${tKey}CODE`)}
                controlLabel={t(`${tKey}CODE`)}
              />
            </div>
            <SimpleTablePage
              // customClass={'langTable'}
              columns={[
                <th className='colWidth-15 alignC' key={2}>
                  {t('MASTERS.LANGUAGE')}
                </th>,
                <th className='colWidth-30' key={0}>
                  {t('MASTERS.NAME')}
                </th>,
                <th className='colWidth-55' key={1}>
                  {t('MASTERS.DESCRIPTION')}
                </th>
              ]}
              rows={languageList && languageList.map((val, idx) => (
                <tr key={idx}>
                  <td className='alignC'>
                    <p><span>{`${val.description}`}</span></p>
                    <p>{`(${val.name})`}</p>
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.name`}
                      placeholder={t('MASTERS.NAME')}
                      maxLength={50}
                    />
                  </td>
                  <td>
                    <Field
                      component={InputText}
                      colWidth={100} // 25, 33, 50, 75, 100 default=25
                      name={`lang${val.languageId}.description`}
                      placeholder={t('MASTERS.DESCRIPTION')}
                      maxLength={100}
                    />
                  </td>
                </tr>
              ))}
            />
          </Modal.Body>
          <Modal.Footer>
            <Col sm={12} className="flexInLine al-R">
              <Button type="submit" className="_Btn new" disabled={this.props.pristine}>
                {t('MASTERS.SAVE')}
              </Button>
            </Col>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'editMaritalStatus',
  validate: (values, props) => {
    const tKey = 'MASTERS.MARITAL_STATUS_MASTERS.MODAL.VALIDATION.'
    let error = {}

    if (!values.code) {
      error.code = props.t(`${tKey}CODE`)
    }

    props.languageList && props.languageList?.forEach((element) => {
      let valueLangName = values['lang' + element.languageId].name
      let valueLangDesc = values['lang' + element.languageId].description
      let errorLang = {
        name: null,
        description: null
      }
      if (!valueLangName) {
        errorLang.name = props.t(`${tKey}NAME`)
      } else if (valueLangName.length > 50) {
        errorLang.name = props.t(`${tKey}NAME_LENGTH`)
      }
      if (!valueLangDesc || valueLangDesc.length > 50) {
        errorLang.description = props.t(`${tKey}DESCRIPTION`)
      } else if (valueLangDesc.length > 50) {
        errorLang.description = props.t(`${tKey}DESCRIPTION_LENGTH`)
      }
      error['lang' + element.languageId] = errorLang
    })

    return Object.keys(error).length > 0 ? error : {}
  }
})(MaritalStatusMasterModal)
